import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import green from '@mui/material/colors/green';
import red from '@mui/material/colors/red';
import { TableRow, TableCell } from '@mui/material';

import shallowEqual from 'app/lib/shallow-equal';
import i18n from 'app/common/i18n';

@i18n
class StatItem extends Component {
  static propTypes = {
    cellClassName: PropTypes.string,
    item: PropTypes.object.isRequired,
    admin: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      shallowEqual(this.props, nextProps) && shallowEqual(this.state, nextState)
    );
  }

  showAudit = () => {
    this.handleMenuClose();
    this.props.onAuditOpen(this.props.item.uuid);
  };

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { item, cellClassName } = this.props;

    const location = item.location || {};
    const uuid = item.uuid;

    const address = (
      <span>
        {(location.address || this.props.i18n('(no address)')).replace(
          /, [0-9]{4} [A-ZÆØÅ].*/,
          ''
        )}
        <br />
        {location.zip ? `${location.zip} ${location.city || ''}` : ''}
      </span>
    );

    const bbmails = item.accepted || '-';
    const contactSuccess = item.success || '-';
    const contactForbidden = item.forbidden || '-';
    const unique = item.uniqueClicks || '-';
    const total = item.totalClicks || '-';

    const active = item.active;
    const locked = item.status === 'APPROVED';

    return (
      <TableRow
        style={{
          background:
            item.status === 'APPROVED'
              ? active
                ? green[50]
                : '#fff'
              : item.status === 'REJECTED'
              ? red[50]
              : '#fff',
          opacity: active ? 1 : 0.5,
          textAlign: 'left'
        }}
      >
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap' }}
        >
          {uuid && active ? (
            <Link
              to={locked ? `/dwellings/${uuid}/preview` : `/dwellings/${uuid}`}
            >
              {address}
            </Link>
          ) : (
            address
          )}
        </TableCell>

        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
          align="center"
        >
          {bbmails}
        </TableCell>

        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {unique}
        </TableCell>

        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {total}
        </TableCell>

        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {contactSuccess}
        </TableCell>

        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {contactForbidden}
        </TableCell>

        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {item.facebook ? (
            <a href={item.facebook} target="_blank" rel="noopener noreferrer">
              {this.props.i18n('Facebook')}
            </a>
          ) : (
            '-'
          )}
        </TableCell>

        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {item.akutbolig ? (
            <a href={item.akutbolig} target="_blank" rel="noopener noreferrer">
              {this.props.i18n('Akutbolig')}
            </a>
          ) : (
            '-'
          )}
        </TableCell>
      </TableRow>
    );
  }
}

export default StatItem;